import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { PRIMARY_COLORS } from '../../common/colors';

// Webflow section_testimonial1: centered quote on the light-brand surface.
const Testimonial = ({ quote, name, role }) => (
  <Box sx={{ backgroundColor: PRIMARY_COLORS['95'] }}>
    <Container maxWidth="md" sx={{ py: { xs: 6, md: 8 }, textAlign: 'center' }}>
      <Typography sx={{ color: 'surface.dark', fontSize: { xs: '1.125rem', md: '1.25rem' }, fontWeight: 500, lineHeight: 1.6, mb: 3 }}>
        “{quote}”
      </Typography>
      <Typography sx={{ color: 'surface.dark', fontWeight: 700 }}>{name}</Typography>
      <Typography variant="body2" sx={{ color: 'surface.contrastText' }}>{role}</Typography>
    </Container>
  </Box>
);

export default Testimonial;
